<template>
    <button
        ref="button"
        class="v-kebab-button"
        :class="{ active: isOpen }"
        :disabled="isDisabled"
        :title="disabledReason"
        @click.stop="toggle"
        @dblclick.stop
    >
        <VIcon material="more_vert"/>
    </button>

    <VPopup
        :target="buttonEl"
        :visible="isOpen"
        :offset="0"
        align="right"
        @update:visible="onVisibleChange"
        @click.stop="closeMenu"
    >
        <slot/>
    </VPopup>
</template>

<style lang="scss" src="./VKebabButton.scss"/>

<script lang="ts">
/**
 * Координатор открытых меню, одновременно открыт только один кебаб
 */
let openKebab: { closeMenu(): void } | null = null;

export default defineComponent({
    name: 'VKebabButton',

    props: {
        disabled: {
            type:    [String, Boolean] as PropType<string | boolean | null>,
            default: null,
        },
    },

    data() {
        return {
            isOpen:   false,
            buttonEl: null as HTMLElement | null,
        };
    },

    computed: {
        isDisabled(): boolean {
            if (this.disabled === null)  return false;
            if (this.disabled === false) return false;
            return true;
        },

        disabledReason(): string | undefined {
            if (typeof this.disabled === 'string' && this.disabled.length > 0) {
                return this.disabled;
            }
            return undefined;
        },
    },

    mounted() {
        this.buttonEl = this.$refs.button as HTMLElement;
    },

    beforeUnmount() {
        // Снимаем регистрацию, если размонтируется открытый кебаб
        if (openKebab === this) {
            openKebab = null;
        }
    },

    methods: {
        toggle(): void {
            if (this.isOpen) {
                this.closeMenu();
            } else {
                this.openMenu();
            }
        },

        openMenu(): void {
            // Закрываем ранее открытый кебаб вручную - сам он не закроется
            if (openKebab && openKebab !== this) {
                openKebab.closeMenu();
            }
            this.isOpen = true;
            openKebab   = this;
        },

        closeMenu(): void {
            this.isOpen = false;
            if (openKebab === this) {
                openKebab = null;
            }
        },

        onVisibleChange(value: boolean): void {
            if (value) {
                this.openMenu();
            } else {
                this.closeMenu();
            }
        },
    },
});
</script>
